import React, { useEffect } from 'react';

const YearPickerModal = ({ 
  showYearPicker, 
  selectYear, 
  closeYearPicker,
  activeYearItemId,
  modalData,
  updateModalData
}) => {
  // Закрытие по Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeYearPicker();
      }
    };
    if (showYearPicker) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [showYearPicker, closeYearPicker]);

  if (!showYearPicker) return null;

  return (
    <div className="picker-overlay" onClick={closeYearPicker}>
      <div className="picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="picker-header">
          <h3>Выберите год</h3>
          <button className="picker-close" onClick={closeYearPicker}>×</button>
        </div>
        
        <div className="picker-content">
          <ul className="picker-list year-picker-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {Array.from({ length: 20 }, (_, i) => {
              const year = new Date().getFullYear() - 10 + i;
              const currentYear = new Date().getFullYear();
              const isCurrentYear = year === currentYear;
              const isSelected = modalData.find(item => item.id === activeYearItemId)?.godpovr === year.toString();
              
              return (
                <li
                  key={year}
                  className={`picker-item ${isSelected ? 'selected' : ''} ${isCurrentYear ? 'current-year' : ''}`}
                  onClick={() => {
                    updateModalData(activeYearItemId, 'godpovr', year.toString());
                    closeYearPicker();
                  }}
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                    fontWeight: isCurrentYear ? 'bold' : 'normal',
                    color: isCurrentYear ? '#1976d2' : 'inherit'
                  }}
                >
                  {year}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default YearPickerModal;

